import { ReactNode, FC } from 'react';
import { Settings } from '@ant-design/pro-layout';
import App from './App';

export default App;
export interface Handbook {
  title: string;
  url: string;
}

export interface LayoutSettings extends Omit<Settings, 'footerRender'> {
  // 国际化标题 key，覆盖title
  titleId?: string;
  pwa?: boolean;
  // 全局页脚，或自定义页脚
  footerRender?: boolean | ReactNode;
  // 顶部导航右上角
  rightRender?: boolean | ReactNode;
  // 顶部导航右上角功能项，若重写了rightRender，该项将不起作用
  rightRenderItems?: (props: any) => ReactNode[];
  // 用户手册
  handbooks?: Handbook[];
  // 自定义layout分发
  layoutSwitch?: FC;
}

export { default as Footer } from './components/Footer';

export * from './utils/utils';
